<template>
  <modal @close="close">
    <h2 slot="header">{{title}}</h2>

    <div class="md-layout" slot="body">
      <form class="md-layout-item" id="highway_form" @submit.prevent="saveHighway()">

        <div class="md-layout">
          <div class="md-layout-item md-medium-size-100" >
            <md-field :class="validationClass('highwayCompany')">
              <label for="highway_company">Compania Carretera</label>
              <md-select
              data-vv-name="highwayCompany"
              v-validate="modelValidations.highwayCompany"
              v-model="updatedHighway.highwayCompany"
              name="highway_company">
                <md-option v-for="highwayCompany in highwayCompanies" :value="highwayCompany.id" :key="highwayCompany.id">
                  {{highwayCompany.name}}
                </md-option>
              </md-select>
              <error-indicator :valid="validField('highwayCompany')"></error-indicator>
            </md-field>
          </div>
        </div>

        <div class="md-layout">
          <div class="md-layout-item md-medium-size-100" >
            <md-field :class="validationClass('customer')">
              <label for="customer">Cliente</label>
              <md-select
              data-vv-name="customer"
              v-validate="modelValidations.customer"
              v-model="updatedHighway.customer"
              name="customer">
                <md-option v-for="customer in customers" :value="customer.id" :key="customer.id">
                  {{customer.name}}
                </md-option>
              </md-select>
              <error-indicator :valid="validField('customer')"></error-indicator>
            </md-field>
          </div>
        </div>

        <div class="md-layout">
          <div class="md-layout-item md-medium-size-50" >
            <md-field :class="validationClass('name')">
              <label for="name">Nombre</label>
              <md-input
                data-vv-name="name"
                v-validate="modelValidations.name"
                v-model="updatedHighway.name">
              </md-input>
              <error-indicator :valid="validField('name')">
              </error-indicator>
            </md-field>
          </div>

          <div class="md-layout-item md-medium-size-50" >
            <md-field :class="validationClass('highwayNumber')">
              <label for="name">Nombre clave</label>
              <md-input
                data-vv-name="highwayNumber"
                v-validate="modelValidations.highwayNumber"
                v-model="updatedHighway.highwayNumber">
              </md-input>
              <error-indicator :valid="validField('highwayNumber')">
              </error-indicator>
            </md-field>
          </div>
        </div>

        <div class="md-layout">
          <md-field class="md-layout-item md-size-100">
            <label for="description">Descripcion</label>
            <md-textarea v-model="updatedHighway.description"></md-textarea>
          </md-field>
        </div>
      </form>
    </div>

    <template slot="footer">
      <md-button type="submit" form="highway_form" class="md-success">
        Aceptar
      </md-button>
      <md-button @click="close">
        Cancelar
      </md-button>
    </template slot="footer">
  </modal>
</template>

<script>

import { mapState } from 'vuex'
import { ImageField, Modal } from '@/components'
import catalogService from '@/services/catalog'
import ErrorIndicator from "@/components/Validation/ErrorIndicator"

const modelValidations = {
  name: {
    required: true
  },
  highwayCompany: {
    required: true
  },
  customer: {
    required: true
  },
  highwayNumber: {
    required: true
  }
}

export default {

  name: 'EditHighway',

  components: {
    ImageField,
    ErrorIndicator,
    Modal
  },

  props: {
    highway: Object,
    title: {
      type: String,
      default: "Editar autopista"
    }
  },

  data() {
    return {
      updatedHighway: {},
      modelValidations,
      touched: {
      },
      defaultHighway: {
        isActive: true,
      }
    }
  },
  methods: {
    close() {
      this.$emit('close')
    },
    saveHighway() {
      const payload = { original: this.highway, updated: this.updatedHighway }
      this.$validator.validateAll().then(isValid => {
        if (isValid) {
          this.$emit('saved', payload)
        } 
      })
    }
  },
  mounted() {
    this.updatedHighway = { ...this.defaultHighway, ...this.highway }
    this.watchTouched({ updatedHighway: Object.keys(modelValidations) })
  },
  computed: {
    ...mapState('catalogs', {
      highwayCompanies: s => s.highwaycompany,
      customers: s => s.customer
    })
  },
}
</script>



// WEBPACK FOOTER //
// src/pages/Catalogs/Highway/Edit.vue